import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ViewWillEnter } from '@ionic/angular';
import { ModalController } from '@ionic/angular';
import { ToasterService } from "../../../../common/services/toaster.service";
import { CreateWorkOrderService } from "../../../g-route/services/create-work-order.service";
import { GarmentReportService } from '../../services/garment-report.service';
import { EmployeeKey } from '../../../../../app/common/models/employee-key.model';
import { GtrakAuthService } from '../../../../../app/features/authentication/services/gtrak-auth.service';
import { GtrakUser } from '../../../../../app/features/authentication/models/gtrak-user';
import { EmployeeListing } from '../../../../common/models/employee-listing.model';
import { GarmentWeeklyHistoryModalComponent } from '../../components/garment-weekly-history-modal/garment-weekly-history-modal.component';
import { ConfirmationPopupComponent } from '../../../admin-page/components/confirmation-popup/confirmation-popup.component';
import _ from "lodash";

@Component({
  selector: 'app-employee-garment-report-page',
  templateUrl: 'employee-garment-report.page.html',
  styleUrls: [
    './employee-garment-report.page.scss',
  ]
})
export class EmployeeGarmentReportPage implements ViewWillEnter, OnInit {

  employeeId: string;
  customerId: string;
  departmentId: string;
  garmentCode: string;
  requestParams: any;
  results: any;
  public report: any;
  public customer: any;
  empKey: EmployeeKey;
  doneLoading: boolean = false;
  garmentCodeProductCodes = [];
  garmentMessageCodes = [];
  garmentSummaryStatusCodes = [];
  loaded: boolean = false;
  summaryNotes = []
  currentDate: Date;
  public viewChange: boolean = false;
  user: GtrakUser;
  IsCancelEmpAllow: boolean = false;
  workOrderNumber: string;
  ShowSuccessMessage: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private garmentReportService: GarmentReportService,
    private modalController: ModalController,
    private authService: GtrakAuthService,
    private createWorkOrderService: CreateWorkOrderService,
    private toasterService: ToasterService
  ) {

  }

  ngOnInit(): void {
    this.loaded = false;
    if (!this.authService.user.canViewGarmentListing) {
      this.router.navigate([this.authService.user.homeLocation]);
    }
    this.currentDate = new Date;
    this.loaded = true;
    //Aloha Added this to check if user can place order or not and based on that show/hide the cancel employee button
    this.IsCancelEmpAllow = this.authService.user.CanViewCancelEmp;
  }

  async ionViewWillEnter(): Promise<void> {
    this.loaded = false;
    this.employeeId = this.route.snapshot.paramMap.get('id');
    this.customerId = this.route.snapshot.paramMap.get('cid');
    this.departmentId = this.route.snapshot.paramMap.get('did');
    this.garmentCode = this.route.snapshot.paramMap.get('gid');

    this.empKey = {
      CustomerCode: this.customerId,
      DepartmentCode: this.departmentId,
      EmployeeCode: this.employeeId
    };

    await this.setData();
    this.loaded = true;

  }

  changePrinterView(): void {
    this.viewChange = !this.viewChange;
    setTimeout(() => {
      print();
    }, 1000);
  }

  async setData(): Promise<void> {
    this.loaded = false;
    this.report = this.garmentCode ? await this.garmentReportService.findForGarment(this.garmentCode) : await this.garmentReportService.getForEmployee(this.empKey);
    this.garmentCode = this.report?.garmentCode ?? this.garmentCode;
    _.each(this.report.summary, (sum) => {
      if (sum.status == "1" || sum.status == "10" || sum.status == "11" || sum.status == "4" || sum.status == "8" || sum.status == "9") {
        if (sum.status.length > 0) {
          this.summaryNotes.push({
            'status': sum.status,
            'statusDesc': sum.statusDesc
          })
        }
      }
    });
    this.summaryNotes = [...this.summaryNotes];
    this.report.notes = this.report.notes.filter((test, index, array) =>
      index === array.findIndex((find) => find.code === test.code)
    );
    if (this.garmentCode) {
      _.each(this.report.details, (detail) => {
        if (detail.garmentCode == this.garmentCode) {
          this.garmentCodeProductCodes.push(detail.productCode);
          this.garmentMessageCodes.push(detail.messageCode);
        }
      });
      _.each(this.report.summary, (summary) => {
        if (this.garmentCodeProductCodes.includes(summary.productCode)) {
          this.garmentSummaryStatusCodes.push(summary.status);
        }
      });
    }
    this.summaryNotes = this.summaryNotes.filter((test, index, array) =>
      index === array.findIndex((find) => find.status === test.status)
    );
    this.customer = this.report.employeeListing;
    this.doneLoading = true;
    this.loaded = true;
  }
  async openWeeklyHistoryModal(employee: EmployeeListing): Promise<void> {
    const modal = this.modalController.create({
      component: GarmentWeeklyHistoryModalComponent,
      componentProps: {
        'employee': employee
      },
      cssClass: "min-width-modal-md",
      showBackdrop: true,
      backdropDismiss: true,
      keyboardClose: true,
      swipeToClose: true,

    });
    (await modal).present();
    const { data } = await (await modal).onDidDismiss();
  }
  openWorkOrder(data) {
    this.router.navigate(['/work-order/employee/' + data.employeeCode + '/' + data.customerCode + '/' + data.departmentCode]);
  }

  async submitCancelItem(): Promise<void> {
    //check if selected list is empty
    // this.loaded=false;

    const modal = this.modalController.create({
      component: ConfirmationPopupComponent,
      cssClass: "min-width-modal",
      showBackdrop: true,
      componentProps: {
        workOrder: 'Are you sure you would like to cancel this employee (' + this.customer.employeeCode + ' ' + this.customer.lastName + ' ' + this.customer.firstName + ')?'
      },
      backdropDismiss: true,
      keyboardClose: true,
      swipeToClose: true,
    });

    (await modal).present();
    const { data } = await (await modal).onDidDismiss();

    if (data) {
      this.loaded = false;
      await this.createWorkOrderService
        .SubmitCancelComplete(
          this.authService.user.id,
          this.customerId,
          this.employeeId,
          this.departmentId,
          this.customer.stopCode,
          "XC"
        )
        .then(async (res) => {
          const num = Number(res);
          if (!res) {
            this.toasterService.presentToast(
              "danger",
              "",
              "There are no items to cancel",
              3000
            );
          } else if (!Number.isNaN(num) && Number.isInteger(num)) {
            //   this.toasterService.presentToast(
            //     "primary",
            //     "",
            //     "Cancel Item Work Order Created: " + num,
            //     3000
            //   );
            //  this.setData();
            this.setData();
            this.workOrderNumber = num.toString();
            this.ShowSuccessMessage = true;
          } else {
            this.toasterService.presentToast(
              "danger",
              "",
              String(res),
              3000
            );
          }
        });
    }
    this.loaded = true;
  }
    goToMainScreen(): void {
    this.router.navigate([this.authService.user?.homeLocation || '/garment-listing']);
  }

}